import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { Navbar, Loading } from './components';
import { PrivateRoute } from './routes';
import {
  Login,
  Dashboard,
  Samples,
  Team,
  Parameters,
  CreateSample,
  MySamples,
  Analyse,
  PublicPortal,
  Settings,
  MasterData
} from './pages';

function App() {
  const { loading, isAuthenticated, user } = useAuth();

  if (loading) {
    return <Loading message="Loading application..." />;
  }

  // Route for authenticated users after login
  const getAuthenticatedRoute = () => {
    switch (user?.role) {
      case 'ADMIN':
        return '/dashboard';
      case 'TEAM_MEMBER':
        return '/mobile';
      default:
        return '/';
    }
  };

  return (
    <div className="app">
      <Navbar />
      <main className="main-content">
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={
            isAuthenticated ? <Navigate to={getAuthenticatedRoute()} /> : <Login />
          } />
          <Route path="/portal" element={<PublicPortal />} />
          <Route path="/" element={<PublicPortal />} />

          {/* Admin Routes */}
          <Route path="/dashboard" element={
            <PrivateRoute roles={['ADMIN']}>
              <Dashboard />
            </PrivateRoute>
          } />
          <Route path="/samples" element={
            <PrivateRoute roles={['ADMIN']}>
              <Samples />
            </PrivateRoute>
          } />
          <Route path="/parameters" element={
            <PrivateRoute roles={['ADMIN']}>
              <Parameters />
            </PrivateRoute>
          } />
          <Route path="/team" element={
            <PrivateRoute roles={['ADMIN']}>
              <Team />
            </PrivateRoute>
          } />
          <Route path="/settings" element={
            <PrivateRoute roles={['ADMIN']}>
              <Settings />
            </PrivateRoute>
          } />
          <Route path="/master-data" element={
            <PrivateRoute roles={['ADMIN']}>
              <MasterData />
            </PrivateRoute>
          } />

          {/* Team Member Routes */}
          <Route path="/mobile" element={
            <PrivateRoute roles={['TEAM_MEMBER']}>
              <MySamples />
            </PrivateRoute>
          } />
          <Route path="/my-samples" element={
            <PrivateRoute roles={['TEAM_MEMBER']}>
              <MySamples />
            </PrivateRoute>
          } />
          <Route path="/create-sample" element={
            <PrivateRoute roles={['TEAM_MEMBER', 'ADMIN']}>
              <CreateSample />
            </PrivateRoute>
          } />
          <Route path="/analyse" element={
            <PrivateRoute roles={['TEAM_MEMBER', 'ADMIN']}>
              <Analyse />
            </PrivateRoute>
          } />

          {/* Catch-all Route - redirect to portal */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
